export default __webpack_public_path__ + "static/media/1849.8e7d72c1.png";